import { AboutHero } from "@ui/Organisms/About/AboutHero";
import {
	AboutStory,
	type AboutStoryContent,
} from "@ui/Organisms/About/AboutStory";
import { AppShell } from "@ui/Organisms/Layout/AppShell";
import type * as React from "react";

export type AboutHeroContent = {
	image: string;
	imageAlt: string;
	eyebrow: string;
	title: string;
	tagline: string;
	logo?: string;
};

type Props = {
	topBar: React.ReactNode;
	tabBar: React.ReactNode;
	footer?: React.ReactNode;
	hero: AboutHeroContent;
	story: AboutStoryContent;
};

export function AboutTemplate({ topBar, tabBar, footer, hero, story }: Props) {
	return (
		<AppShell topBar={topBar} tabBar={tabBar} footer={footer}>
			<AboutHero {...hero} />
			<AboutStory {...story} />
		</AppShell>
	);
}
